import React from 'react';
import { Element } from 'react-scroll';
import { CustomPhotoSwipe, Submenu } from '../components';

export default (props) => (
	<div className="Content Downloads-Content">

		<span className="Mob-Title"> <h3 className="red-txt"> Downloads </h3> </span>

	    <h2> Baixe aqui fontes, <br/> imagens e ícones. </h2>

      <Submenu
        links={[
          { to: "logos", title: "Logos", offset: -270 },
          { to: "imagens", title: "Imagens", offset: -270 },
          { to: "icones", title: "Ícones", offset: -290 },
          { to: "fontes", title: "Fontes", offset: -290 },
          { to: "cores", title: "Cores", offset: -290 }
        ]} />

	    <h1 className="red-txt"> Logos </h1>

	    <Element name="logos" className="Block">
	    	<div className="Img-Wrapper Center">
          <CustomPhotoSwipe items={[{
              src: require('../img/Downloads/logos.jpg'),
              w: 1003,
              h: 561,
              title: 'Logos'
            }]}>
            <div className="Img-Wrapper first">
              <img src={require("../img/Downloads/logos.jpg")}/>
              <div className="lupa"> <img src={require("../img/lupa.svg")}/> </div>
            </div>
          </CustomPhotoSwipe>

    		</div>
      <a className="download-btn" href="https://d3e275zh299c67.cloudfront.net/logos.zip" target="_blank"> Download <img src={require("../img/Downloads/download.svg")}/> </a>

	    </Element>

	    <h1 className="red-txt"> Imagens Próprias </h1>

      <Element name="imagens">
	     <Element className="Block">
	    	<div className="Img-Wrapper Center">
          <CustomPhotoSwipe items={[{
              src: require('../img/Downloads/imagensProprias.jpg'),
              w: 1003,
              h: 561,
              title: 'Imagens'
            }]}>
            <div className="Img-Wrapper first">
              <img src={require("../img/Downloads/imagensProprias.jpg")}/>
              <div className="lupa"> <img src={require("../img/lupa.svg")}/> </div>
            </div>
          </CustomPhotoSwipe>

    		</div>

        <a className="download-btn" href="https://d3e275zh299c67.cloudfront.net/imagens-proprias.zip" target="_blank"> Download <img src={require("../img/Downloads/download.svg")}/> </a>

	    </Element>

      <h1 className="red-txt"> Imagens Licenciadas </h1>

	     <Element name="imagensL" className="Block">
	    	<div className="Img-Wrapper Center">
          <CustomPhotoSwipe items={[{
              src: require('../img/Downloads/imagensLicenciadas.jpg'),
              w: 1003,
              h: 561,
              title: 'Imagens'
            }]}>
            <div className="Img-Wrapper first">
              <img src={require("../img/Downloads/imagensLicenciadas.jpg")}/>
              <div className="lupa"> <img src={require("../img/lupa.svg")}/> </div>
            </div>
          </CustomPhotoSwipe>

    		</div>

        <a className="download-btn" href="https://d3e275zh299c67.cloudfront.net/imagens-licenciadas.zip" target="_blank"> Download <img src={require("../img/Downloads/download.svg")}/> </a>

	    </Element>
    </Element>

	    <h1 className="red-txt"> Bancos de ícones </h1>

	    <Element name="icones" className="Block">
	    	<div className="Img-Wrapper Center">
          <CustomPhotoSwipe items={[{
              src: require('../img/Downloads/icones.jpg'),
              w: 1003,
              h: 561,
              title: 'Icones'
            }]}>
            <div className="Img-Wrapper first">
              <img src={require("../img/Downloads/icones.jpg")}/>
              <div className="lupa"> <img src={require("../img/lupa.svg")}/> </div>
            </div>
          </CustomPhotoSwipe>

    		</div>

      <a className="download-btn" href="https://d3e275zh299c67.cloudfront.net/banco-de-icones.zip" target="_blank"> Download <img src={require("../img/Downloads/download.svg")}/> </a>

	    </Element>

	    <h1 className="red-txt"> Tipografia </h1>

	    <Element name="fontes" className="Block">
	    	<div className="Img-Wrapper Center">
          <CustomPhotoSwipe items={[{
              src: require('../img/EVisual/tipografia.jpg'),
              w: 1003,
              h: 561,
              title: 'Tipografia'
            }]}>
            <div className="Img-Wrapper first">
              <img src={require("../img/EVisual/tipografia.jpg")}/>
              <div className="lupa"> <img src={require("../img/lupa.svg")}/> </div>
            </div>
          </CustomPhotoSwipe>

    		</div>

      <a className="download-btn" href="https://d3e275zh299c67.cloudfront.net/tipografia.zip" target="_blank"> Download <img src={require("../img/Downloads/download.svg")}/> </a>

	    </Element>

	    <h1 className="red-txt"> Cores </h1>

	     <Element name="cores" className="Block">
	    	<div className="Img-Wrapper Center">
          <CustomPhotoSwipe items={[{
              src: require('../img/Downloads/cores.png'),
              w: 1003,
              h: 561,
              title: 'Cores'
            }]}>
            <div className="Img-Wrapper first">
              <img src={require("../img/Downloads/cores.png")}/>
              <div className="lupa"> <img src={require("../img/lupa.svg")}/> </div>
            </div>
          </CustomPhotoSwipe>

    		</div>

      <a className="download-btn" href="https://d3e275zh299c67.cloudfront.net/cores.zip" target="_blank"> Download <img src={require("../img/Downloads/download.svg")}/> </a>

	    </Element>
	</div>

);



// WEBPACK FOOTER //
// ./src/pages/Downloads.js